import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ContentQualityScorer from "./ContentQualityScorer";
import MedicalAccuracyValidator from "./MedicalAccuracyValidator";
import DifficultyAnalyzer from "./DifficultyAnalyzer";
import ContentHealthMonitor from "./ContentHealthMonitor";
import { QualityDashboard } from "./QualityDashboard";
import { CheckCircle, Stethoscope, BarChart3, Activity, TrendingUp } from "lucide-react";

export default function AIQualityAnalytics() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card className="border-primary/20 bg-gradient-to-br from-background to-primary/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <CheckCircle className="h-4 w-4 text-primary" />
              Quality Scoring
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              AI-powered content quality assessment
            </p>
          </CardContent>
        </Card>

        <Card className="border-success/20 bg-gradient-to-br from-background to-success/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <Stethoscope className="h-4 w-4 text-success" />
              Medical Accuracy
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              Validate medical content accuracy
            </p>
          </CardContent>
        </Card>

        <Card className="border-warning/20 bg-gradient-to-br from-background to-warning/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <BarChart3 className="h-4 w-4 text-warning" />
              Difficulty Analysis
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              Automatic difficulty assessment
            </p>
          </CardContent>
        </Card>

        <Card className="border-destructive/20 bg-gradient-to-br from-background to-destructive/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <Activity className="h-4 w-4 text-destructive" />
              Health Monitor
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              Overall content health tracking
            </p>
          </CardContent>
        </Card>
      </div>

      <Tabs defaultValue="dashboard" className="w-full">
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="dashboard" className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4" />
            Dashboard
          </TabsTrigger>
          <TabsTrigger value="quality" className="flex items-center gap-2">
            <CheckCircle className="h-4 w-4" />
            Quality
          </TabsTrigger>
          <TabsTrigger value="accuracy" className="flex items-center gap-2">
            <Stethoscope className="h-4 w-4" />
            Accuracy
          </TabsTrigger>
          <TabsTrigger value="difficulty" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            Difficulty
          </TabsTrigger>
          <TabsTrigger value="health" className="flex items-center gap-2">
            <Activity className="h-4 w-4" />
            Health
          </TabsTrigger>
        </TabsList>

        <TabsContent value="dashboard" className="mt-6">
          <QualityDashboard />
        </TabsContent>

        <TabsContent value="quality" className="mt-6">
          <ContentQualityScorer />
        </TabsContent>

        <TabsContent value="accuracy" className="mt-6">
          <MedicalAccuracyValidator />
        </TabsContent>

        <TabsContent value="difficulty" className="mt-6">
          <DifficultyAnalyzer />
        </TabsContent>

        <TabsContent value="health" className="mt-6">
          <ContentHealthMonitor />
        </TabsContent>
      </Tabs>
    </div>
  );
}